import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Offering from "./pages/Offering";
import Work from "./pages/Work";
import Events from "./pages/Events";
import Resources from "./pages/Resources";
import Assessment from "./pages/Assessment";
import Contact from "./pages/Contact";
import BookingConfirmed from "./pages/BookingConfirmed";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import "./styles/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="offering" element={<Offering />} />
          <Route path="work" element={<Work />} />
          <Route path="events" element={<Events />} />
          <Route path="resources" element={<Resources />} />
          <Route path="assessment" element={<Assessment />} />
          <Route path="contact" element={<Contact />} />
          <Route path="contact/booked" element={<BookingConfirmed />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
